module.exports = __webpack_public_path__ + "static/media/Avatar10.90ea630c.svg";